import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import confetti from "canvas-confetti";
import { StyledPublicQuestionForm } from "./index.styled";
import Header from "./components/Header";
import SuccessCard from "./components/SuccessCard";
import QuestionForm from "./components/QuestionForm";
import Footer from "./components/Footer";
import PageTitleSubtitle from "../../components/shared/PageTitleSubtitle";
import {
  fetchBoxByPublicId,
  createAnonymousQuestion,
} from "../../utils/apiService";

const PublicQuestionForm = () => {
  const { identifier } = useParams<{ identifier: string }>();
  const [answer, setAnswer] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [boxData, setBoxData] = useState<{
    id: string;
    title: string;
    short_code: string;
  } | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!identifier) {
      setLoading(false);
      return;
    }

    const loadBox = async () => {
      try {
        const data = await fetchBoxByPublicId(identifier);
        setBoxData({
          id: data.id,
          title: data.title,
          short_code: data.short_code,
        });
        setError(null);
      } catch (err) {
        console.error("Failed to fetch question box:", err);
        setError("לא ניתן למצוא את תיבת השאלות");
      } finally {
        setLoading(false);
      }
    };

    void loadBox();
  }, [identifier]);

  const handleSubmit = async () => {
    if (!answer.trim() || !boxData?.id) return;

    setIsSubmitting(true);
    setError(null);

    try {
      await createAnonymousQuestion(boxData.id, answer.trim(), "web");
      setShowSuccess(true);
      setAnswer("");
      void confetti({
        particleCount: 150,
        spread: 70,
        origin: { y: 0.6 },
        colors: ["#FFD700", "#FFA500", "#FF4500", "#DA70D6", "#32CD32", "#00BFFF"],
      });
    } catch (err) {
      console.error("Failed to submit answer:", err);
      setError("שגיאה בשליחת התגובה. נסה שוב.");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (loading) {
    return (
      <StyledPublicQuestionForm>
        <p className="loading-message">טוען...</p>
      </StyledPublicQuestionForm>
    );
  }

  if (!boxData && !loading) {
    return (
      <StyledPublicQuestionForm>
        <p className="not-found-message">
          לא ניתן למצוא את תיבת השאלות. ייתכן שהקישור אינו תקין.
        </p>
      </StyledPublicQuestionForm>
    );
  }

  return (
    <StyledPublicQuestionForm>
      <Header />

      {error && <p className="error-message">{error}</p>}

      <PageTitleSubtitle
        title="מישהו מחכה לתגובה שלך"
        subtitle="התגובה שלך נשלחת באופן אנונימי"
      />

      <div className="form-content-wrapper">
        {showSuccess ? (
          <SuccessCard onSendAnother={() => setShowSuccess(false)} />
        ) : (
          <QuestionForm
            title={boxData?.title || "מה בא לכם לאכול היום?"}
            answer={answer}
            setAnswer={setAnswer}
            isSubmitting={isSubmitting}
            onSubmit={handleSubmit}
          />
        )}
        <Footer />
      </div>
    </StyledPublicQuestionForm>
  );
};

export default PublicQuestionForm;
